<template lang="en">
<div class="doctor-profile">
    <Navigation></Navigation>
    
    <Loader :show="loading" type="inline"></Loader>
    <Loader :show="purchasing" ></Loader>

    <div class="container margin_60" v-if="!loading">
        <div class="row">
            
            <aside class="offset-md-1 col-md-10 offset-lg-3 col-lg-6" id="sidebar">
                <div class="box_general_3 booking">
                    <div>
                        <div class="title">
                            <h3>Finalizar compra</h3>
                        </div>

                        <div class="card-doctor">
                            <figure class="profile-picture">
                                <div class="image" v-if="this.clinic.picture" :style="'background-image:url('+API_URL+this.clinic.picture.urlThumb+')'"></div>
                                <div class="avatar" v-else :style="'background-image:url('+require('@/assets/img/no-avatar-image-thumb.gif')+')'"></div>
                            </figure>
                            <div class="profile-data">
                                <h2>{{this.clinic.name}}</h2>
                                <div class="subtitle">
                                    <span v-for="service in this.clinic.services" :key="service.id">{{service.service.name}} </span>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="summary" v-if="purchase">
                            <ul>
                                <li>Ubicación: 
                                    <strong class="float-right text-right">{{ purchase.address.locality.name }}, {{ purchase.address.locality.region.name}} </strong>
                                </li>
                            </ul>
                        </div>
                        <hr>
                        <ul class="summary">
                            <li class="total">
                                <span class="text-secondary">{{purchase.service.service.category.name}} </span><br>
                                {{purchase.service.service.name}} 
                                <strong class="float-right">$ {{purchase.price}}</strong>
                            </li>
                        </ul>
                        <hr>
                        <div class="p-3">
                            
                            <div class="alert alert-danger text-center" v-if="!loggedUser.is_completed">
                                Debe completar sus datos personales para poder finalizar la compra.<br><br>
                                <router-link to="/profile" tag="a" class="btn btn-sm btn-danger">Actualizar datos personales</router-link>
                            </div>

                            <Payment 
                                v-if="loggedUser.is_completed"
                                :amount="purchase.price" 
                                ref="PaymentComponent" 
                                @paymentDone="paymentDone" 
                                @paymentClosed="paymentClosed" >
                            </Payment>

                            <button class="btn_1 full-width" @click="confirmPurchase()" v-if="!purchasing">Confirmar y pagar</button>
                            <button class="btn_1 full-width" v-if="purchasing">Procesando</button>

                            <p class=" text-center highlight mt-2">
                                Una vez que finalices tu compra te enviamos el detalle y los datos de contacto.
                            </p>

                        </div>


                    </div>
                </div>
            </aside>
        </div>
    </div>

    <Footer></Footer>

</div>
</template>

<script>
import gql from 'graphql-tag'
import { mapGetters, mapMutations } from 'vuex'

import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import Loader from '@/components/Loader';
import Payment from '@/components/Payment';


export default {
    name: 'Checkout',
    metaInfo: {
		title: 'Finalizar reserva',
	},
    components: {
        Navigation,
        Footer,
        Loader,
        Payment
    },
    computed: {
		...mapGetters(['isAuthenticated','loggedUser','purchase']),
	},
    data() {
        return {
            API_URL: process.env.VUE_APP_API_URL,
            loading: true,
            purchasing:false,
            clinic:{},
            bookingCode: null
        }
    },
    beforeMount(){
        console.log('stored purchase', this.purchase);
        if( 
            !this.purchase.service ||
            this.purchase.service.id <= 0 || 
            !this.isAuthenticated
        ){
            this.$router.go(-1)
        }
    },
    mounted(){
        this.loadClinic();
    },
    methods:{
        ...mapMutations(['removePurchase']),
        loadClinic() {
			this.$apollo.query({
				query: gql`query getClinic($id: ID!) {
					clinicCenter(id: $id){
                        id
                        name
                        picture{
                            urlThumb
                        }
                        services{
                            id
                            service{
                                name
                                category{ name }
                            }
                        }
					}
                }`,
                variables:{
                    id: this.purchase.clinic_id,
                },
			})
			.then((data) => {
                this.clinic = data.data.clinicCenter;
                this.loading= false;
			});
			
        },
        confirmPurchase(){
            
            if( !this.purchasing ){
                this.saving=true;

                let paymentValidate = { valid: false }

                
                paymentValidate = this.$refs.PaymentComponent.validate()
                 

                if (paymentValidate.valid) {
                
                    this.purchasing = true;
                
                    let dataInput = {
                        user_id: this.loggedUser.id,
                        clinic_id: this.purchase.clinic_id,
                        clinic_service_id: this.purchase.service.id,
                        clinic_address_id: this.purchase.address.id,
                    }

                    this.$apollo.mutate({
                        mutation: gql`mutation ( $data:ClinicServicePurchaseInput! ){
                            clinicServicePurchase( data: $data) {
                                id
                                code
                                user{
                                    name
                                    lastname
                                    email
                                    doc_type
                                    doc_number
                                }
                            }
                        }`,
                        variables: {
                            data: dataInput,
                        }
                    })
                    .then((data) => {
                        this.purchaseCode = data.data.clinicServicePurchase.code;
                        // if( this.purchase.coupon ){
                        //     this.paymentDone(this.bookingCode, data.data.bookingCreate)
                        // }else{
                            this.$refs.PaymentComponent.proccess(data.data.clinicServicePurchase, 'clinicService');
                        // }
                        // this.$ga.event('users', 'booking-created', this.bookingCode)
                    })
                    .catch(error => {
                        console.log('error al crear la reserva.',error);
                        this.purchasing = false;
                    });
                
                } else {
                    this.saving=false;
                    this.$toast.error(paymentValidate.err);
                }
            }
        },
        paymentDone(purchaseCode,data){
            console.log('paymentDone', purchaseCode, data)
            if (!purchaseCode) {
                alert(data)
            }else{
                this.removePurchase();
                this.$router.push(`/service-checkout/${purchaseCode}/payment`);
                
            }
            this.purchasing = false;
        },
        paymentClosed (paying) {
            console.log('paymentClosed on Checkout detail',paying)
            this.removePurchase();
            this.purchasing = false;
            this.$router.push('/service-checkout/'+ this.purchaseCode +'/payment');
            
        },
    }
}
</script>

<style scoped>
.booking .title {
  background-color: #12bcec;
  color: #fff;
  
  padding: 20px 30px;
  -webkit-border-radius: 5px 5px 0 0;
  -moz-border-radius: 5px 5px 0 0;
  -ms-border-radius: 5px 5px 0 0;
  border-radius: 5px 5px 0 0;
}
.booking .title h3 {
  font-size: 1.5rem;
  margin: 0;
  color: #fff;
}
.booking .title small {
  font-size: 13px;
  font-size: 0.8125rem;
}
.booking .summary{
    padding: 18px;
    margin: 0px;
    font-size: 14px;
}
.booking .summary ul{
    margin: 0px;
}
.booking .summary .total{
    font-size: 17px;
}
.booking hr {
  margin: 15px 0px;
}
.booking ul.treatments {
    padding: 18px;
}
.booking ul.treatments li {
  border-top: 1px dotted #ddd;
  border-bottom: none;
  width: 100%;
  margin: 0;
  padding: 12px 0 5px 0;
}
@media (max-width: 991px) {
  .booking ul.treatments li {
    /* For less than 991px */
    width: auto;
    float: none;
  }
}





</style>
